import React from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'zh', label: '简体中文' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'ar', label: 'العربية' },
  { code: 'fr', label: 'Français' },
  { code: 'pt', label: 'Português (Brasil)' },
  { code: 'ru', label: 'Русский' },
  { code: 'bn', label: 'বাংলা' },
  { code: 'de', label: 'Deutsch' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'it', label: 'Italiano' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'ur', label: 'اردو' },
  { code: 'fa', label: 'فارسی' },
  { code: 'th', label: 'ไทย' },
  { code: 'pl', label: 'Polski' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'sw', label: 'Kiswahili' },
  { code: 'no', label: 'Norsk' },
  { code: 'ms', label: 'Bahasa Melayu' },
  { code: 'my', label: 'မြန်မာ' }
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  return (
    <div className="mb-4 flex justify-end">
      <select
        value={i18n.language}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        className="border rounded p-1 bg-white text-black hover:text-black focus:text-black"
      >
        {languages.map((lng) => (
          <option key={lng.code} value={lng.code} className="text-black">
            {lng.label}
          </option>
        ))}
      </select>
    </div>
  );
}